import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// Shared breadcrumb used across Knowledge Centre and Service pages.
// Ensures consistent Montserrat typography, weights, alignment and graceful
// wrapping/truncation on small screens with no horizontal overflow.
export const Breadcrumb = ({ to, label, current, testId, tone = "dark" }) => {
  const linkColor =
    tone === "dark"
      ? "text-emerald-300 hover:text-emerald-200"
      : "text-emerald-700 hover:text-emerald-800";
  const sepColor = tone === "dark" ? "text-white/30" : "text-slate-300";
  const currentColor = tone === "dark" ? "text-emerald-300/90" : "text-emerald-700/90";

  return (
    <nav
      aria-label="Breadcrumb"
      data-testid={testId}
      className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm leading-6 min-w-0 max-w-full"
    >
      <Link
        to={to}
        className={`inline-flex items-center gap-1.5 font-medium tracking-normal transition-colors ${linkColor}`}
      >
        <ArrowLeft size={16} className="shrink-0" aria-hidden="true" />
        <span>{label}</span>
      </Link>
      {current && (
        <>
          <span className={`${sepColor} select-none`} aria-hidden="true">
            /
          </span>
          <span
            className={`block truncate max-w-[55vw] sm:max-w-none font-semibold uppercase tracking-[0.06em] ${currentColor}`}
          >
            {current}
          </span>
        </>
      )}
    </nav>
  );
};
